import React from 'react';

/**
 * A course's progress bar on the continue-learning grid.
 *
 * 12px of track — white, ringed in gray/250 — with a 10px green fill inside
 * it. The 1px of daylight on each side is the design's, and it is what stops a
 * bar at 100% from looking like a plain green pill.
 *
 * The fill is pinned to the track's inline start, so it grows from the right in
 * Arabic and the left in English. It is absolutely positioned, so the pin has
 * to be a logical inset — `left`/`right` would not follow the direction. The
 * inline *end* would fill Arabic from the left (EDU-006).
 *
 * `value` is clamped rather than trusted. Historical progress values can come
 * back above 100 after course content changes, and an unclamped fill would
 * overhang its track.
 */
const clamp = (value) => Math.min(100, Math.max(0, Math.round(value || 0)));

const Progress = ({ value, label }) => {
    const percent = clamp(value);

    return (
        <div
            role="progressbar"
            aria-valuenow={percent}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={label}
            className={
                'tw-relative tw-h-[12px] tw-w-full tw-overflow-hidden tw-rounded-full ' +
                'tw-border tw-border-solid tw-border-v2-ground-500 tw-bg-white'
            }
        >
            <div
                className="tw-absolute tw-top-1/2 tw--translate-y-1/2 tw-h-[10px] tw-rounded-full tw-bg-v2-student-progress tw-transition-[width] tw-duration-500"
                style={{ insetInlineStart: '1px', width: percent ? `calc(${percent}% - 2px)` : 0 }}
            />
        </div>
    );
};

export default Progress;
